import { gql } from 'apollo-boost';

export const ME = gql`
    query {
        me {
            id
            email
            fullName
            isVerified
            role
            planType
            quota {
                maxMessages
                totalMessages
                maxStorage
                totalStorage
                maxFileSize
                maxCredits
                credits
            }
            profilePictureUrl
            homeFolder
            savedBackgroundImageUrls
            backgroundImageUrl
            backgroundVariant
            backgroundDimEnabled
            spokenLanguages
            defaultTranscriptionLanguage
            spokenLanguagesConfigured
            timezone
            createdAt
            deletedAt
            discoverySource
            discoverySourceOther
            referralId
            referralCount
            referralCountMax
            emergencyBuffer
            aiFeaturesEnabled
            aiOrganizationEnabled
            dailyReviewContentTypes
            dailyReviewExcludedFolderIds
            dailyReviewOnboardingCompleted
            dailyReviewDepth
            dailyReviewUseEmojis
            dailyReviewLanguage
            dailyReviewEnabled
            messageGroupingEnabled
            dailyReviewEmailEnabled
            dailyReviewEmailFrequency
            dailyReviewPushEnabled
            autoDownloadGithubReposEnabled
            autoTranscribeVoiceNotesEnabled
            telegramVoiceTranscriptionReplyEnabled
            adhdMode
            aiOrganizationIntroSeenVersion
            stripeCustomerId
            isSubscribedToMarketingEmails
            isSubscribedToNewsletter
            hasCustomOpenAIKey
            openaiApiKeyStatus
            hasCustomGroqKey
            groqApiKeyStatus
            hasActiveSubscription
            activePurchases {
                id
                provider
                subscriptionStatus
                store
                plan {
                    stripePriceId
                    planType
                    name
                }
            }
            integrations {
                whatsapp { id phoneNumber connectedAt }
                telegram {
                    id
                    username
                    connectedAt
                }
                slack {
                    slackUserId
                    teamId
                    username
                    workspaceName
                    displayName
                    connectedAt
                }
            }
            planLimits {
                slackConnections
            }
        }
    }
`;
